// React
import { createContext } from "react"

export const IframeContext = createContext<{
  onClose: () => void
}>({
  onClose() {},
})